import module from "module";

import templateUrl from './pawn-product.template.html';

class PawnProducts {}
module.component('pawnProducts', {
  templateUrl,
  controller: PawnProducts
});
